import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactComponent as ActionIcCheckCircle24px } from '../../assets/icons/action/ic_check_circle_24px.svg';
import { ReactComponent as AlertIcError24px } from '../../assets/icons/alert/ic_error_24px.svg';
import { ReactComponent as AlertIcWarning24px } from '../../assets/icons/alert/ic_warning_24px.svg';
import { ReactComponent as ActionIcInfo24px } from '../../assets/icons/action/ic_info_24px.svg';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 * @prop {{message: React.ReactNode}} [icons]
 * @prop {'error' | 'success' | 'warning' | 'info'} [variant]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifInlineMessage = (props) => {
  const { children, className = '', icons = {}, variant = 'info', ...other } = props;
  const classes = classNames({
    'motif-inline-message': true,
    'motif-inline-message-success': variant === 'success',
    'motif-inline-message-error': variant === 'error',
    'motif-inline-message-warning': variant === 'warning',
    [className]: true
  });

  const icon = useMemo(() => {
    switch (variant) {
      case 'error':
        return <AlertIcError24px />;
      case 'success':
        return <ActionIcCheckCircle24px />;
      case 'warning':
        return <AlertIcWarning24px />;
      case 'info':
      default:
        return <ActionIcInfo24px />;
    }
  }, [variant]);

  return (
    <div className={classes} {...other} data-motif-inline-message>
      <div className="motif-inline-message-content">
        {icons.message || icon}
        {children}
      </div>
    </div>
  );
};

MotifInlineMessage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icons: PropTypes.shape({
    message: PropTypes.node
  }),
  variant: PropTypes.oneOf(['error', 'success', 'warning', 'info'])
};

export { MotifInlineMessage };
